// The budget-template list this form fetches leaves out every budget template
// an offer template points at, so a booker choosing a budget is not offered the
// dozens of internal ones an offer template made for its own line items. That is
// right for CHOOSING, and wrong for the value already attached: a <select> whose
// value matches none of its options renders the first one instead, so the field
// reported "None" for a template that has a budget attached.
//
// So: list stays as fetched, plus the attached one when it is missing from it.
export const budgetTemplateOptions = (budgetTemplates, eventTemplate) => {
  const options = budgetTemplates || [];
  const attachedId = eventTemplate && eventTemplate.v3_budget_template_id;

  if (!attachedId) return options;
  if (options.some(option => option.value === attachedId)) return options;

  return [
    ...options,
    {
      value: attachedId,
      // EventTemplate#as_json sends the name for exactly this. The fallback is
      // for a payload without it — still better than the field claiming None.
      label: eventTemplate.v3_budget_template_name || "Attached budget template"
    }
  ];
};
